/// <amd-module name="Wiki/Overview/Utils/WikiTelemetryHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { WikiType } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { TelemetryConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";
import { publish } from "Wiki/ViewCommon/Utils/WikiHelper";

export function publishWikiPageCommandClicked(
    pageContext: IVssPageContext,
    featureName: string,
    source: string,
    wikiType: WikiType,
    pageId?: number,
    mode?: string,
    actionForCurrentPage?: boolean
): void {
    publish(pageContext, featureName, wikiType, { source, pageId, mode, actionForCurrentPage });
}

export function wikiFilteredPageClicked(pageContext: IVssPageContext, wikiType: WikiType): void {
    publish(pageContext, TelemetryConstants.FilteredPageClicked, wikiType);
}

export function wikiPageFiltered(pageContext: IVssPageContext, wikiType: WikiType): void {
    publish(pageContext, TelemetryConstants.PageFilterPerformed, wikiType);
}
